import { Component } from '@angular/core';
import { LazyLoadDirective } from '@bn/web-ui';
import { NgStyle } from '@angular/common';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'bn-not-found',
  templateUrl: './not-found.page.html',
  styleUrls: ['not-found.page.scss'],
  imports: [LazyLoadDirective, NgStyle, ButtonComponent, RouterLink],
})
export class NotFoundPage {}
